<form class="form-container" [formGroup]="form">
    <h2 mat-dialog-title>{{ 'APPEAL' | translate }}</h2>
    <mat-dialog-content class="mat-typography">

        <div class="row">
            <div class="col-12 align-content-center text-center">
                <img src="assets/images/appeal-1.svg" class="appeal-icon" alt="">
                <!-- <h3 class="action-title">{{'APPEAL' | translate}}</h3> -->
              </div>
            <div class="col-12 text-center">
                <mat-label>{{'APPEAL_CONFIRMATION_TEXT' | translate}}</mat-label>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'COMMENTS' | translate}} </mat-label>
                    <textarea matInput formControlName="comment"></textarea>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
            <button mat-raised-button [disabled]="form.invalid" (click)="appeal()" [mat-dialog-close]="form.value" color="primary"
                    cdkFocusInitial>{{'YES_APPEAL' | translate}} </button>
            <button mat-raised-button mat-dialog-close>{{'Cancel' | translate}}</button>
    </mat-dialog-actions>
</form>